module.exports = __webpack_public_path__ + "img/stretch.67592166.svg";